/* Scripts - Main */

/* Prevent propagation on class */
$(".prevent-click-thru").click(function (event) {
  event.stopPropagation();
  return false;
});

/* On document ready */
$(document).ready(function () {
  /* Add smooth scrolling to all links */
  $("a").on("click", function (event) {
    /* Before overriding default behavior ensure hash has a value */
    if (this.hash !== "") {
      event.preventDefault(); // Prevent default anchor click behavior

      var hash = this.hash; // Store hash
      var offset = $(hash).offset().top; // Get target offset

      offset = hash === "#mission-statement" ? offset - 60 : offset - 120; // Custom offset for mission statement section

      $("html, body").animate({ scrollTop: offset }, 800); // Animate scroll
    }
  });

  /* Side nav trigger */
  $("#burger").click(function (event) {
    $("body").toggleClass("side-nav-open");
  });

  /* Toggle side-nav on overlay click */
  $("#navigation-wrapper").click(function () {
    $("body").toggleClass("side-nav-open");
  });
});
